module.exports = __webpack_public_path__ + "static/media/view.24799a0a.svg";